import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { getFullChartConfig } from './config';
import { useTraceChartContext } from '@/creditflowresearch/application/Trace/TraceChartContext';
import EmptyResultOverlay from '@/creditflowresearch/ui/common/components/EmptyResultOverlay';
import Chart from '@framework/ui/Organisms/Analytics/Chart';
import { ChartTypes } from '@framework/ui/Organisms/Analytics/Chart/constants';

import styles from './traceChart.module.scss';

const TraceChart = (props) => {
  const { chartData: collection, isFetching } = useTraceChartContext();
  const [chartConfig, setChartConfig] = useState(null);
  const traceCollection = collection.map((chartItem) => ({
    ...chartItem,
    data: chartItem.data.map((dataPoint) => [new Date(dataPoint.date).getTime(), dataPoint.price]),
    lineWidth: 1,
    color: chartItem.color,
    marker: {
      enabled: false,
    },
  }));

  useEffect(() => {
    setChartConfig(getFullChartConfig());
  }, []);

  if (collection.length > 0) {
    return (
      <div className={ cn(styles.wrapper, { [styles.wrapperNoData]: !collection.length }) }>
        { collection.length > 0 && (
          <Chart
            className={ styles.chartContainer }
            type={ ChartTypes.Highcharts }
            isFetching={ isFetching }
            data={ collection }
            getConfig={ () => ({ ...chartConfig, series: traceCollection }) }
            zeroCaseLabel={ <EmptyResultOverlay content="No chart data available" /> }
            updateArgs={ [true, true, true] }
            { ...props }
          />
          ) }
      </div>
    );
  }

  return null;
};

export default TraceChart;
